import React from "react";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import {
  MapPin,
  UserCog,
  Users,
  AlignLeft,
} from "lucide-react";
import { GiCricketBat } from "react-icons/gi";

const ViewTrainingModal = ({
  data,
  onClose,
  onDelete,
  onParticipants,
  onAthletes,
  onEquipment,
  onAttendance,
  onViewAttendance,
  loading,
}) => {

  const navigate = useNavigate();

  const totalAthletes = data?.batches?.reduce(
    (sum, batch) => sum + (batch?.total_athletes || 0),
    0
  );

  const totalEquipment = data?.equipments?.reduce(
    (sum, item) => sum + (item?.quantity || 0),
    0
  );

  const totalAthletesCount = data?.athletes?.length

  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

  const canEdit = (batchUserLevel) => {
    // If loginDetails is not present, allow edit
    if (!loginDetails) {
      return true;
    }

    // If present, compare user levels
    return loginDetails?.user?.user_level === batchUserLevel;
  };

  const isCoach = localStorage.getItem("category_type") === "2";
  const today = new Date().toISOString().slice(0, 10);
  const isTrainingActiveToday =
    data?.training_date <= today &&
    (!data?.training_end_date || data?.training_end_date >= today);
  const canTakeAttendance = isCoach
    ? isTrainingActiveToday
    : data?.supervisors?.some(s => Number(s.id) === Number(loginDetails?.user?.id));
  const userLevel = loginDetails?.user?.user_level;
  const canViewAttendance = userLevel === 2 || userLevel === 3;

  return (
    <div className="training-modal-overlay">

      <div className="training-modal">

        {/* HEADER */}
        <div className="training-header">
          <h5>View Training</h5>

          <div className="header-actions">
            {/* <button className="icon-btn" onClick={() => navigate(`/batch-management/calendar/update/${data?.id}`)}>
              <FiEdit />
            </button> */}
            {canEdit(data?.user_level) ? (
              <button className="icon-btn" onClick={() => navigate(`/batch-management/calendar/update/${data?.id}`)}>
                <FiEdit />
              </button>
            ) : (
              <div
                className="icon_wrapper mx-2"
                style={{
                  opacity: 0.2,
                  cursor: "not-allowed",
                  pointerEvents: "none",
                }}
              >
                <i className="bi bi-pencil"></i>
              </div>
            )}

            <button
              className="icon-btn"
              onClick={onDelete}
            >
              <FiTrash2 />
            </button>
          </div>
        </div>


        {/* TRAINING TITLE */}
        <div className="training-title">
          <span className="training-dot"></span>
          <h6>{data?.training_name || "-"}</h6>
        </div>

        <p className="training-date">
          <p className="training-date">
            {data?.training_date
              ? dayjs(data.training_date).format("dddd, DD MMM YYYY")
              : "No date available"}
          </p>
        </p>

        <p className="training-time">
          {data?.start_time && data?.end_time
            ? dayjs(`${data.training_date} ${data.start_time}`).format("hh:mm A")
            : "No time available"}
        </p>


        {/* VENUE */}
        <div className="training-section">
          <div className="taining-section-title">
            <MapPin size={18} className="section-icon" />
            <h6>Venue</h6>
          </div>
          <p>{data?.venue_name || "Venue not available"}</p>
        </div>


        {/* SUPERVISOR */}
        <div className="training-section">
          <div className="taining-section-title">
            <UserCog size={18} className="section-icon" />
            <h6>Supervisor</h6>
          </div>

          <div className="supervisor-list">
            {data?.supervisors?.length > 0 ? (
              data?.supervisors?.map((item, index) => (
                <div key={index} className="supervisor-chip">
                  <span>
                    {[item?.first_name, item?.last_name].filter(Boolean).join(" ").trim() || "—"}
                    {(item?.role_name || item?.role) && (
                      <small className="text-muted ms-1">
                        ({item?.role_name || item?.role})
                      </small>
                    )}
                    {item?.atom_id && (
                      <small className="text-muted ms-1">
                        #{item.atom_id}
                      </small>
                    )}
                  </span>
                  {/* <button
                    type="button"
                    onClick={(e) => {
                      
                    }}
                  >
                    ×
                  </button> */}
                </div>
              ))
            ) : (
              <p>No supervisors assigned</p>
            )}
          </div>
        </div>


        {/* PARTICIPANTS */}
        <div className="training-section">
          <div className="taining-section-title">
            <div className="common-display-gap-flex">
              <div className="title-left">
                <Users size={18} className="section-icon" />
                <h6>Participant</h6>
              </div>

            </div>
          </div>
          <div className="taining-section-title" style={{ 'marginTop': '0px', 'marginBottom': '0px' }}>
            <div className="common-display-gap-flex" style={{ 'gap': '16rem' }}>
              <div className="title-left">
                {/* <Users size={18} className="section-icon" /> */}
                <h6>Batch ({totalAthletes})</h6>
              </div>
              <button
                className="view-link"
                onClick={onParticipants}
              >
                View All
              </button>
            </div>
          </div>
          <div className="participant-card-header-flex">
            {data?.batches?.length > 0 ? (
              data?.batches?.slice(0, 2)?.map((item) => (
                <div className="participant-card" key={item?.id}>
                  <p>
                    {item?.batch_name}
                  </p>
                  <span>{item?.sport_name}</span> || <span>{item?.total_athletes ?? 0} Athletes</span>
                </div>
              ))
            ) : (
              <p>No participants assigned</p>
            )}
          </div>
        </div>

        {/* Individual */}
        <div className="training-section">
          <div className="taining-section-title" style={{ 'marginTop': '0px', 'marginBottom': '0px' }}>
            <div className="common-display-gap-flex" style={{ 'gap': '15rem' }}>
              <div className="title-left">
                {/* <Users size={18} className="section-icon" /> */}
                <h6>Athletes ({totalAthletesCount})</h6>
              </div>
              <button
                className="view-link"
                onClick={onAthletes}
              >
                View All
              </button>
            </div>
          </div>
          <div className="participant-card-header-flex">
            {data?.athletes?.length > 0 ? (
              data?.athletes?.slice(0, 2)?.map((item) => (
                <div className="participant-card" key={item?.id}>
                  <p>
                    {item?.first_name + ' ' + item?.last_name}
                  </p>
                  <span>{item?.sport_name}</span>
                </div>
              ))
            ) : (
              <p>No Athletes assigned</p>
            )}
          </div>
        </div>

        {/* EQUIPMENT */}
        <div className="training-section">
          <div className="taining-section-title">
            <div className="common-display-gap-flex">
              <div className="title-left">
                <GiCricketBat size={18} className="section-icon" />
                <h6>Equipment ({totalEquipment})</h6>
              </div>
              <button
                className="view-link"
                onClick={onEquipment}
              >
                View All
              </button>
            </div>
          </div>
          <div className="equipment-flex-wrap">
            {data?.equipments?.length > 0 ? (
              data?.equipments?.slice(0, 4)?.map((item) => (
                <span key={item?.id} className="equipment-chip">
                  {item?.item_name}: {item?.quantity}
                </span>
              ))
            ) : (
              <p>No equipment assigned</p>
            )}
          </div>
        </div>



        {/* DESCRIPTION */}
        <div className="training-section">
          <div className="taining-section-title">
            <AlignLeft size={18} className="section-icon" />
            <h6>Description</h6>
          </div>
          <p>{data?.description || "No description added"}</p>
        </div>


        {/* FOOTER */}
        <div className="modal-footer" style={{ 'padding': '0px 0px', 'display': 'flex', 'gap': '8px', 'alignItems': 'center' }}>
          {canTakeAttendance && (
            <button className="btn btn-primary btn-sm" onClick={onAttendance}>
              Take Attendance
            </button>
          )}
          {canViewAttendance && (
            <button className="btn btn-outline-secondary btn-sm" onClick={onViewAttendance}>
              View Attendance
            </button>
          )}
          <button className="close-btn" onClick={onClose}>
            Close
          </button>
        </div>

      </div>

    </div>
  );
};

export default ViewTrainingModal;